import { HubloPoolApplicationStatus } from '@front/type/pool'
import type { WorkerProfile } from '@front/type/worker/worker'

import { isAppAndroid, isAppIOS } from '../others/devices'

import type { Device } from './types/device'
import type { SegmentWorkerProperties } from './types/segmentProperties'

const isMobile = (): boolean =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i.test(
    global.navigator.userAgent,
  )

const getDevice = (): Device => {
  if (isAppAndroid()) {
    return 'APP_ANDROID'
  } else if (isAppIOS()) {
    return 'APP_IOS'
  } else if (isMobile()) {
    return 'MOBILE_BROWSER'
  }
  return 'WEB_BROWSER'
}

type UserId = { userId: string }
type HubloId = { hubloId: string }

export const identifyWorkerToSegmentProperties = (
  user: WorkerProfile,
  hubloPoolApplicationStatus: HubloPoolApplicationStatus,
  lang: string,
  poolAcceptedAt?: string,
): UserId & HubloId & SegmentWorkerProperties => ({
  userId: user.hubloId ?? '',
  hubloId: user.hubloId ?? '',
  type: 'Worker',
  lang,
  medium: getDevice(),
  institutionId: user.institutions?.map((institution) =>
    institution.id.toString(),
  ),
  email: user.email,
  firstName: user.firstName,
  lastName: user.lastName,
  phone: user.phone,
  createdAt: user.createdAt,
  pool: hubloPoolApplicationStatusToSegmentProperties(
    hubloPoolApplicationStatus,
  ),
  poolAcceptedAt,
})
export const hubloPoolApplicationStatusToSegmentProperties = (
  hubloPoolApplicationStatus: HubloPoolApplicationStatus,
) => {
  switch (hubloPoolApplicationStatus) {
    case HubloPoolApplicationStatus.ACCEPTED:
      return 'Subscribed'
    case HubloPoolApplicationStatus.NEW:
    case HubloPoolApplicationStatus.PENDING_REVIEW:
      return 'Pending'
    case HubloPoolApplicationStatus.DISABLED:
    case HubloPoolApplicationStatus.DECLINED:
      return 'Deleted'
    case HubloPoolApplicationStatus.NONE:
    default:
      return 'Not registered'
  }
}

export const companyIdFromWorkerInstitutions = (
  worker: WorkerProfile,
  institutionId: number,
): string | undefined =>
  worker.institutions?.find(({ id }) => id === institutionId)?.uuid.toString()
